import { withInstall } from '@fx-front-framework/utils/with-install'
import SearchBar from './src/search-bar.vue'

export const FxSearchBar = withInstall(SearchBar)
export default FxSearchBar
